import React from 'react'

const ManageOrders = () => {
  return (
    <div>
      
    </div>
  )
}

export default ManageOrders
